import DynamicForm from "../common/DynamicForm";
import { useEffect, useState } from "react";
import EndEndorment from "./EndEndorment";

const PrimarySystemForm = (props: any) => {
  const { register, control, errors, watch, setValue, setPriMode, isView } =
    props;

  const [showPassword, setShowPassword] = useState(false);
  const [temp, setTemp] = useState(0);

  const fieldsJson = [
    {
      groupName: "primary_system",
      title: "Primary System",
      fields: [
        {
          name: "mode",
          label: "Connection mode",
          size: 12,
          required: true,
          inputType: "radio",
          options: ["SFTP", "API"],
          optionFlex: "row",
          defaultValue: "SFTP",
        },
        {
          name: "data_format",
          label: "Data Format*",
          size: 4,
          inputType: "dropdown",
          options: [
            { value: "json", label: "JSON" },
            { value: "csv", label: "CSV" },
          ],
        },
        {
          name: "base_url",
          label: "Base URL",
          size: 4,
          required: true,
          visibility: "false",
        },
        {
          name: "base_folder_path",
          label: "Base Folder Path",
          size: 4,
          required: true,
        },
        {
          name: "base_api_path",
          label: "Base API Path",
          size: 4,
          required: true,
          visibility: "false",
        },
        {
          name: "username",
          label: "Username",
          size: 4,
          required: true,
          autocomplete: "off",
        },
        {
          name: "password",
          label: "Password",
          size: 4,
          required: true,
          type: showPassword ? "text" : "password",
          autocomplete: "off",
          InputProps: {
            endAdornment: (
              <EndEndorment show={showPassword} setShow={setShowPassword} />
            ),
          },
        },
        {
          name: "sftp_host",
          label: "SFTP Host",
          size: 4,
          required: true,
          visibility: "true",
        },
        {
          name: "sftp_port",
          label: "SFTP Port",
          size: 4,
          required: true,
          visibility: "true",
          inputType: "number",
          type: "tel",
        },
        {
          name: "study_file_id",
          label: "Study File Identifier",
          size: 4,
          required: true,
          visibility: "true",
        },
        {
          name: "study_json_path",
          label: "Study JSON Path",
          size: 4,
          required: true,
          visibility: "false",
        },
        {
          name: "mapping_id",
          label: "Mapping Id",
          size: 4,
          required: true,
        },
        {
          name: "token_url",
          label: "Token URL",
          size: 4,
          required: true,
          visibility: "false",
        },
      ],
    },
  ];
  const [fields, setFields] = useState(fieldsJson);

  const watchMode = watch("mode");

  useEffect(() => {
    if (watchMode == "API") {
      const temp = fields?.map((item: any) => {
        return {
          ...item,
          fields: item.fields?.map((field: any) => {
            if (
              field.name == "base_folder_path" ||
              field.name == "sftp_host" ||
              field.name == "sftp_port" ||
              field.name == "study_file_id"
            ) {
              return { ...field, visibility: "false" };
            } else if (
              field.name == "base_api_path" ||
              field.name == "study_json_path" ||
              field.name == "token_url" ||
              field.name == "base_url"
            ) {
              return { ...field, visibility: "true" };
            } else {
              return field;
            }
          }),
        };
      });
      setPriMode("API");
      setValue("base_folder_path", "");
      setValue("sftp_host", "");
      setValue("sftp_port", "");
      setValue("study_file_id", "");
      setFields(temp);
    }
    if (watchMode == "SFTP") {
      const temp = fields?.map((item: any) => {
        return {
          ...item,
          fields: item.fields?.map((field: any) => {
            if (
              field.name == "base_folder_path" ||
              field.name == "sftp_host" ||
              field.name == "sftp_port" ||
              field.name == "study_file_id"
            ) {
              return { ...field, visibility: "true" };
            } else if (
              field.name == "base_api_path" ||
              field.name == "study_json_path" ||
              field.name == "token_url" ||
              field.name == "base_url"
            ) {
              return { ...field, visibility: "false" };
            } else {
              return field;
            }
          }),
        };
      });
      setPriMode("SFTP");
      setValue("base_api_path", "");
      setValue("study_json_path", "");
      setValue("token_url", "");
      setValue("base_url", "");
      setFields(temp);
    }
    setTemp(temp + 1);
  }, [watchMode]);

  console.debug(fields);

  useEffect(() => {
    if (!isView) {
      const temp = fields?.map((item: any) => {
        return {
          ...item,
          fields: item.fields?.map((field: any) => {
            if (field.name == "password") {
              return {
                ...field,
                type: showPassword ? "text" : "password",
                InputProps: {
                  endAdornment: (
                    <EndEndorment
                      show={showPassword}
                      setShow={setShowPassword}
                    />
                  ),
                },
              };
            } else {
              return field;
            }
          }),
        };
      });
      setFields(temp);
    }
  }, [showPassword]);

  return (
    <DynamicForm
      // key={temp}
      fieldsJson={fields}
      errors={errors}
      register={register}
      control={control}
      groups
    />
  );
};

export default PrimarySystemForm;
